module.exports = __webpack_public_path__ + "media/images/icons/icon_plus-df907e698668295814021798394d3c93.svg";